import {
  Timestamp,
  arrayUnion,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { v4 as uuid } from "uuid";
import { customOrderByDESC } from "./helper";
import { notifyMany } from "./notify";

const sanitizePlanObj = (others) => {
  const temp = {};
  Object.keys(others).forEach((key) => {
    temp[key] = others[key];
    if (
      !others[key] &&
      others[key] !== false &&
      others[key] !== "" &&
      !["participants", "material"].includes(key)
    ) {
      temp[key] = "";
    } else {
      temp[key] = others[key];
    }
  });
  return temp;
};

export const getInvitesInRealTime = (cb) => {
  return onSnapshot(
    query(collection(db, "invites")),
    (doc) => {
      const dataSnaps = [];
      doc.forEach((each) => {
        const temp = each.data();
        const object = {
          ...temp,
          temp: temp.timestamp.seconds,
        };
        dataSnaps.push(object);
      });
      cb(customOrderByDESC(dataSnaps));
    },
    (err) => {
      console.error("Invites listener error:", err);
    }
  );
};

export const createInvite = (
  { participants, material, ...others },
  setInvite,
  sender
) => {
  const inviteId = uuid();
  const payload = {
    id: inviteId,
    ...sanitizePlanObj(others),
    participants,
    material,
    status: others.status || "draft",
    sender: sender || null,
    timestamp: Timestamp.now(),
  };
  setInvite(payload);
  return setDoc(doc(db, "invites", inviteId), payload);
};

export const updateInvite = (id, { participants, material, ...others }) => {
  let payload = { ...sanitizePlanObj(others) };
  if (participants) {
    const sanitizedParticipants = participants.map((each) =>
      sanitizePlanObj(each)
    );
    payload = { ...payload, participants: sanitizedParticipants };
  }
  return updateDoc(doc(db, "invites", id), {
    ...payload,
    updated: Timestamp.now(),
  });
};

export const updateInviteStatus = async (id, status) => {
  await updateDoc(doc(db, "invites", id), {
    status,
    updated: Timestamp.now(),
  });
  // Notify participants when meeting is activated
  if (status === "active") {
    getDoc(doc(db, "invites", id)).then((snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      const participantIds = (data.participants || [])
        .map((p) => p.userId)
        .filter((uid) => uid && uid !== data.sender);
      if (participantIds.length) {
        notifyMany({
          recipientIds: participantIds,
          category: "meetings",
          title: "New Meeting",
          body: data.topic || data.title || "A meeting has been scheduled",
          data: { inviteId: id },
        }).catch(() => {});
      }
    }).catch(() => {});
  }
};

export const addMaterial = (id, material) => {
  const invitesRef = doc(db, "invites", id);
  return updateDoc(invitesRef, {
    material: arrayUnion(material),
  });
};
